import styled, { css } from 'styled-components';
import { FOCUS_OUTLINE_STYLE, getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/common';
import { Icon } from '../Icon';
import { getTypographyOptions } from '../typography/helpers';
import { getLinkToken } from './tokens';
import { LinkProps } from './types';

export const getTextDecoration = ({ disabled, underline }: LinkProps) => css`
    text-decoration: ${underline ? 'underline' : 'none'};
    &:hover {
        text-decoration: ${underline && !disabled ? 'none' : 'underline'};
    }
`;

export const LinkStyled = styled.a<LinkProps>`
    display: inline;

    color: ${getLinkToken('color')};

    cursor: pointer;
    background: transparent;
    border: none;
    padding: 0;

    ${getTextTokenPreset('bodyLarge')};
    font-size: inherit;
    font-weight: inherit;

    ${({ standalone, size }) =>
        standalone &&
        size === 'small' &&
        css`
            ${getTextTokenPreset('bodyMedium')};
        `}

    ${({ standalone, strong }) =>
        standalone &&
        strong &&
        css`
            font-weight: ${getToken('fontWeight500')};
        `}

    ${({ disabled }) =>
        disabled &&
        css`
            cursor: not-allowed;
        `}

    &:focus-visible {
        ${FOCUS_OUTLINE_STYLE}
        border-radius: ${getToken('borderRadius50')}px;
    }

    &:hover {
        color: ${getLinkToken('color', 'hover')};
    }

    &:active {
        color: ${getLinkToken('color', 'active')};
    }

    ${getTextDecoration}
    ${getTypographyOptions}
`;

export const LinkIcon = styled(Icon)`
    margin-left: ${getSpacingToken('100')}px;
    vertical-align: middle;
`;

export const StandaloneContainer = styled.div`
    display: block;
    width: 100%;
`;
